import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => ({
  tickets: {
    width: '100%',
    minHeight: '100%',
    padding: '30px',
    boxSizing: 'border-box',
    display: 'grid',
    gridTemplateColumns: '2fr 6fr',
    gap: '30px',
    overflow: 'hidden',
    maxWidth: '1750px',
    margin: '0 auto',
  },
  ticketsFilters: {
    height: '100%',
    width: '100%',
    background: theme.palette.background.paper,
    borderRadius: '15px',
    padding: '20px',
    boxSizing: 'border-box',
  },
  filtersGroup: { padding: '5px 0' },
  filterGroupHeader: {
    color: theme.palette.text.primary,
    margin: '5px 0',
    textTransform: 'uppercase',
    fontWeight: 800,
  },
  filtersList: { display: 'flex', gap: '5px', flexDirection: 'column' },
  activeFilter: {
    background: 'var(--color-primary)',
    color: 'white !important',
    '& svg': { '& path': { fill: 'white !important' } },
  },
  filter: {
    '&.MuiButtonBase-root': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      color: theme.palette.text.primary,
      cursor: 'pointer',
      padding: '5px 15px',
      boxSizing: 'border-box',
      borderRadius: '10px !important',
      border: 'none',
    },
    '& svg': { width: '20px', '& path': { fill: theme.palette.text.primary } },
  },
  filterName: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 800,
    gap: '10px',
  },
  ticketsContent: {
    display: 'grid',
    gridTemplateRows: '90px 1fr 60px',
    gap: '20px',
    height: '100%',
    overflow: 'hidden',
  },
  searchContainer: {
    background: theme.palette.background.paper,
    padding: '20px',
    borderRadius: '15px',
    display: 'grid',
    gridTemplateColumns: '1fr 3fr',
    gap: '30px',
  },
  ticketsList: {
    background: theme.palette.background.paper,
    padding: '20px',
    borderRadius: '15px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    overflow: 'auto',
    maxHeight: '56vh',
  },
  ticketListHeader: { display: 'flex', justifyContent: 'space-between' },
  ticketsStats: {
    display: 'flex',
    gap: '10px',
    color: theme.palette.text.primary,
    fontWeight: 800,
    fontSize: '14px',
    alignItems: 'center',
    width: '100%',
    '& svg': {
      width: '24px',
      height: '24px',
      cursor: 'pointer',
      '& path': {
        stroke: theme.palette.text.primary,
      },
    },
  },
  ticketStatsClosed: {
    color: 'grey',
  },
  ticketsListLoading: {
    width: '30px',
    height: '30px',
  },
  ticketListItemStatus: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    color: theme.palette.text.primary,
    '& svg': { '& path': { fill: theme.palette.text.primary } },
  },
  ticketListItem: {
    padding: '5px 10px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '1px solid #d4d4d452',
    borderRadius: '5px',
    cursor: 'pointer',
    '&:hover': { borderColor: '#00000061', boxShadow: '0 0 1px 1px #0000001c' },
    '& svg': { width: '30px', height: '30px' },
  },
  ticketListItemTitle: {
    fontWeight: 800,
    display: 'flex',
    flexDirection: 'row-reverse',
    gap: '10px',
    color: theme.palette.text.primary,
  },
  id: { color: 'grey', fontWeight: 400 },
  searchIcon: { '& path': { fill: theme.palette.text.primary } },
  saveButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: '10px',
  },
  customFilterTicketStatuses: {
    marginTop: '10px',
  },
  chatButtonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    '& svg': { width: '30px', height: '30px', cursor: 'pointer' },
  },
  table: { '& tbody': { maxHeight: '38vh' } },
  link: {
    textDecoration: 'none',
    color: theme.palette.primary.main,
    fontWeight: 700,
  }
}));

export default useStyles;
